// Note: extra types exposed from `index.d.ts`.
export {fromParse5} from './lib/index.js'
